import {UserModel} from './_models'
import {api} from "../../../services/api";
import {AUTH_ME} from "../../../mock/URLs";

export function getUserByToken() {
  try {
    const res = api.get<UserModel>(AUTH_ME);
    return res;
  }catch (error:any) {
    throw error;
  }
}

